import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'

export default function useSeo() {
  const globalStore = useGlobalStore()

  const title = `專題報導｜hengstyle Life｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = globalStore.seoDescriptions.topic
  const url = `${import.meta.env.VITE_DOMAIN}/hence/topic`

  globalStore.setBreadcrumbs([
    { title: 'hengstyle Life', isActive: false, url: '/hence' },
    { title: '專題報導', isActive: true, url: '/hence/topic' }
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description
    // ogImage: faq.value.seo?.og_image?.link,
    // keywords: faq.value.seo?.meta_keywords.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'hengstyle Life',
            item: `${import.meta.env.VITE_DOMAIN}/hence`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '專題報導',
            item: url
          }
        ]
      }
    ]
  })
}
